export enum WorkspaceExpirationFilter {
  Expiring30 = "expiring-30",
  Expiring60 = "expiring-60",
  Expiring90 = "expiring-90",
  Expired = "expired",
}

export const WORKSPACE_EXPIRATION_DAYS = {
  [WorkspaceExpirationFilter.Expiring30]: 30,
  [WorkspaceExpirationFilter.Expiring60]: 60,
  [WorkspaceExpirationFilter.Expiring90]: 90,
} as const;

export const WORKSPACE_DEFAULT_EXPIRATION_DAYS =
  WORKSPACE_EXPIRATION_DAYS[WorkspaceExpirationFilter.Expiring90];

export function workspaceExpirationDays(
  expiration?: WorkspaceExpirationFilter,
) {
  if (!expiration || expiration === WorkspaceExpirationFilter.Expired) {
    return WORKSPACE_DEFAULT_EXPIRATION_DAYS;
  }
  return WORKSPACE_EXPIRATION_DAYS[expiration];
}

export type WorkspaceCredentialExpiration = {
  expiredCount: number;
  expiringCount: number;
  nextExpiresAt: string | null;
};
